import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate() {
    let isAdmin = this.authService.isAdmin();
    console.log("AdminGuard.canActivate() isAdmin:", isAdmin);

    // wenn man auf eine Admin-Seite wollte, aber nicht darf -> dashboard
    // das passiert z.B. bei "MeinBenutzer -> Save" -> statt in die Unternehmenübersicht (darf nur Admin) -> dashboard
    if(isAdmin == false) {
      // MODI: wenn nicht mal eingeloggt, dann nicht nach /, sondern nach /login
      setTimeout(() => {
        let localStorageKeyBENUTZER = 'BENUTZER';
        let localStorageValueBENUTZER = localStorage.getItem(localStorageKeyBENUTZER);
        if(localStorageValueBENUTZER == null) {
          this.router.navigate(['/login']); 
        }
        else {
          this.router.navigate(['/']); 
        }
      }, 250);
    }
    
    return isAdmin; // gehört zum Unternehmen #Administration#
  }
}
